<div class="main">
  <app-menu></app-menu>
  <app-mobile-menu></app-mobile-menu>
  <div class="main__content">
    <router-outlet></router-outlet>
  </div>
  <app-alert-toast-stack></app-alert-toast-stack>
</div>
